var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"bg-transparent hover:bg-blue-900 text-blue-200 font-semibold hover:text-white py-2 px-2 border border-blue-900 hover:border-transparent rounded",on:{"click":_vm.buttonClick}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }